import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import './index.scss';

import ButtonInput from "../../common/ButtonInput";
import MSGDialogue from '../../components/Dialogue';
import axios from 'axios';
import { APIurl } from '../../App';


export default function Register() {

  const [err_ocellphone, setOcellphone] = useState("");
  const [loginmsg, setLogingmsg] = useState("");
  const [colors, setColors] = useState("");
  const [diaglogueID] = useState("msg4");
  const [logging, setLogging] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showPassConfirm, setShowPassConfirm] = useState(false);

 const process = (event) => {
  event.preventDefault();

  setLogging(false);
  setLogingmsg("");

  const memberType = document.getElementById("memberType").value;
  const fnames = document.getElementById("fnames").value;
  const tradeName = document.getElementById("TradeName").value;
  const email = document.getElementById("Email").value;
  const ocellphone = document.getElementById("ocellphone").value;
  const password = document.getElementById("password").value;
  const confirmPassword = document.getElementById("confirmpassword").value;
  const cmd = document.getElementById("cmd").value;

  let ok = true;

  if (ocellphone.length < 10 || isNaN(ocellphone)) {
    setOcellphone("Please enter a valid cellphone number");
    ok = false;
  } else {
    setOcellphone("");
  }

  if (password !== confirmPassword) {
    setLogingmsg("Passwords do not match");
    setColors("text-white bg-danger");
    setLogging(true);
    return;
  }

  if (!ok) return;

  axios.post(APIurl, {
    cmd,
    memberType,
    fnames,
    tradeName,
    email,
    ocellphone,
    password
  })
  .then((response) => {
    const res = response.data;

    document.getElementById("register_form").reset();

    setLogingmsg(res.data);
    setColors(res.success ? "text-white bg-success" : "text-white bg-danger");
    setLogging(true);
  })
  .catch((error) => {
    console.error("Axios error:", error);
    setLogingmsg("An error occurred. Please try again.");
    setColors("text-white bg-danger");
    setLogging(true);
  });
};


  return (
    <>
      {logging && <MSGDialogue msg={loginmsg} id={diaglogueID} colors={colors} />}

      <div className='mr-0 ml-0 p-2 mt-2 mb-0'>
        <h3>Register new Mentor/Client</h3>
      </div>

      <Container fluid className='d-flex flex-row mt-2 w-100 home-cards'>
        <div className='register-container mx-auto my-3 p-3 bg-white rounded animate__animated animate__fadeInDown'>
          
          <form id='register_form' onSubmit={process}>
            <input type="hidden" id="cmd" value="addmember" />

            <div className="theme-color h3">Fill in registration form below</div>
            <hr />

            {/* Member Type */}
            <div className='form-group row'>
              <div className='col-md-5'><b>Member Type:</b></div>
              <div className='col-md-6'>
                <select className="form-control text-center" id="memberType" required>
                  <option value="">-- choose--</option>
                  <option value="Mentor">Mentor</option>
                  <option value="Mentor">Client</option>
                </select>
              </div>
            </div>

            {/* Full Names */}
            <div className='form-group row'>
              <div className='col-md-5'><b>Full names:</b></div>
              <div className='col-md-6'>
                <input className='form-control' id="fnames" required />
              </div>
            </div>

            {/* Trading Name */}
            <div className='form-group row'>
              <div className='col-md-5'><b>Trading Name:</b></div>
              <div className='col-md-6'>
                <input className='form-control' id="TradeName" required />
              </div>
            </div>

            {/* Email */}
            <div className='form-group row'>
              <div className='col-md-5'><b>Email Address:</b></div>
              <div className='col-md-6'>
                <input type="email" className='form-control' id="Email" required />
              </div>
            </div>

            {/* Cellphone */}
            <div className='form-group row'>
              <div className='col-md-5'>
                <b>Cellphone No.:</b>
                <span className='text-danger'>{err_ocellphone}</span>
              </div>
              <div className='col-md-6'>
                <input className='form-control' id="ocellphone" required />
              </div>
            </div>

            {/* Password */}
            <div className='form-group row'>
              <div className='col-md-5'><b>Create Password:</b></div>
              <div className='col-md-6 input-group'>
                <input
                  className="form-control"
                  type={showPass ? "text" : "password"}
                  id="password"
                  required
                />
                <span className="input-group-text" onClick={() => setShowPass(!showPass)}>
                  <i className={`fa ${showPass ? "fa-eye-slash" : "fa-eye"}`} />
                </span>
              </div>
            </div>

            {/* Confirm Password */}
            <div className='form-group row'>
              <div className='col-md-5'><b>Confirm Password:</b></div>
              <div className='col-md-6 input-group'>
                <input
                  className="form-control"
                  type={showPassConfirm ? "text" : "password"}
                  id="confirmpassword"
                  required
                />
                <span className="input-group-text" onClick={() => setShowPassConfirm(!showPassConfirm)}>
                  <i className={`fa ${showPassConfirm ? "fa-eye-slash" : "fa-eye"}`} />
                </span>
              </div>
            </div>

            <ButtonInput value="Add Member" active="btn-deactive my-3" />
          </form>
        </div>
      </Container>
    </>
  );
}
